import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import './OpalAddItemModal.css';

const OpalAddItemModal = ({ show, onHide, data, onAddSelected }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(data);

  const handleSelect = (item) => {
    setSelectedItems((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item]
    );
  };

  const handleAddSelected = () => {
    onAddSelected(selectedItems);
    onHide();
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredData(data);
      return;
    }

    const fd = data.filter((item) =>
      item?.Code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.Description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredData(fd);
  }, [searchTerm, data]);



  useEffect(() => {
    if (!show) {
      setSelectedItems([]); // Reset selected items when modal is closed
      setSearchTerm(''); // Reset search input
      setFilteredData(data); // Reset filtered data
    }
  }, [show, data]);

  return (
    <Modal className="opal-additem-modal" show={show} onHide={onHide} centered>
      <Modal.Header>
        <div className="modal-header-content">
          <div className="modal-title">Add Item</div>
          <div className="input-group search-input">
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <table className="oaim-table">
          <thead className="oaim-table-header">
            <tr>
              <th></th>
              {/* Desktop headers */}
              <th className="d-none d-md-table-cell">Item Code</th>
              <th className="d-none d-md-table-cell">Item Description</th>

              {/* Mobile header */}
              <th className="d-block d-md-none">Item</th>
            </tr>
          </thead>
          <tbody className="oaim-table-body">
            {filteredData.map((item, index) => (
              <tr key={item.id}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedItems.includes(item)}
                    onChange={() => handleSelect(item)}
                  />
                </td>

                {/* Desktop headers */}
                <td className="d-none d-md-table-cell">{item?.Code}</td>
                <td className="d-none d-md-table-cell">{item?.Description}</td>

                {/* Mobile header */}
                <td className="d-block d-md-none">
                  <div className="m-item-code">({item?.Code})</div>
                  <div>{item?.Description}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button-close" onClick={onHide}>
          Cancel
        </Button>
        <Button className="button-add" onClick={handleAddSelected}>
          Add Selected
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OpalAddItemModal;
